import { render } from "./BaseErrorModal.vue?vue&type=template&id=287cc0ca"
import script from "./BaseErrorModal.vue?vue&type=script&lang=js"
export * from "./BaseErrorModal.vue?vue&type=script&lang=js"

import "./BaseErrorModal.vue?vue&type=style&index=0&id=287cc0ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__